export type IHookupSearchInFormLinkSearchPopup = (
  input: HTMLInputElement | JQuery<HTMLInputElement>
) => void;

export function _hookupSearchInFormLinkSearchPopup(
  input: HTMLInputElement | JQuery<HTMLInputElement>
): void {
  $(input)
    .off('keydown')
    .on('keydown', (event) => {
      const key = event.which || event.charCode || event.keyCode;
      if (key === 13) {
        // Enter Key
        const $inputGroup = $(input).parent('.input-group');
        const $searchButton = $inputGroup.find('button');
        $searchButton.trigger('click');
      }
    })
    .focus();
}
